import { WorkflowDto } from '@/models/suba/workflows/WorkflowDTO.model';

import { createContext } from 'react';

export const WorkflowContext = createContext<WorkflowDto | undefined>(
  undefined
);
